import { useTranslation } from "react-i18next";
import PlansService from "../../services/plan.service";
import { useOutletContext, useParams, useSearchParams } from "react-router-dom";
import { useModal } from "../../hooks/useModal";
import { useEffect, useState } from "react";
import { InvoiceStatus } from "./InvoiceStatus";
import { DataLoading } from "../../components/PreLoader/PreLoader";
import DataTable, { DATA_TABLE_TYPES } from "../../components/Table/DataTable";
import InvoicesService from "../../services/invoices.service";
import { uid } from "../../helper";
import { DATA_TABLE_FILTER } from "../../components/Table/FilterPopup";
import { Amount } from "../../components/General/Amount";
import TableAction from "../../components/Table/TableAction";
import { ROUTES } from "../../services/constants";

export const Invoices = ({title}) => {
    const {t} = useTranslation();
    const [searchParams] = useSearchParams();
    const {setPageTitle} = useOutletContext();
    const [plans, setPlans] = useState([]);
    const [downloading, setDownloading] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    let defaultFilterConfig = {};
    if(searchParams.has('order_id'))
        defaultFilterConfig['order_id'] = searchParams.get('order_id');
    useEffect(() => {
        PlansService.listAsOptions().then((data) => {
            setPlans(data);
            setIsLoading(false);
        })
    }, [])
    const columns = [
        { 
            key: "id",
            label: "#",
            sort: true
        },
        { 
            key: "uid", 
            label: t("Account Number"), 
            render: (row) => uid(row.uid), 
            filter: DATA_TABLE_FILTER.INPUT,
            sort: true,
            to: (row) => (`${ROUTES.ACCOUNT_DASHBOARD.replace(':uid', row.uid)}`)
        },
        { 
            key: "order_id", 
            label: t("Invoice Number"), 
            render: (row) => (row.order_id),
            filter: DATA_TABLE_FILTER.INPUT
        },
        { 
            key: "plan_id", 
            label: t("Plan"),
            sort: true,
            render: (row) => (<>{row.plan.name?.['en']}</>),
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: plans
        },
        { 
            key: "amount", 
            label: t("Amount"),
            sort: true,
            render: (row) => (<Amount currency={row.currency} amount={row.price} />)
        },
        { 
            key: "created_at", 
            label: t("Issued Time"), 
            type: DATA_TABLE_TYPES.DATE_TIME,
            sort: true,
            filter: DATA_TABLE_FILTER.DATE_RANGE
        },
        { 
            key: "status", 
            label: t("Status"), 
            render: (row) => <InvoiceStatus row={row} label={true}/>,
            filter: DATA_TABLE_FILTER.CHOOSE_OPTIONS,
            options: [
                { key: "0", value: t("Issued") }, 
                { key: "1", value: t("Processed") }, 
                { key: "2", value: t("Unpaid") }
            ]
        }
        

    ]
    useEffect(() => { 
        setPageTitle(title??t("Invoices"));
    }, [setPageTitle]);
    const handleDownloadPdf = (data) => {
        if(downloading) return;
        setDownloading(data.id)
        InvoicesService.download(data.order_id).then(response => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${data.uid}-invoice.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setDownloading(null);
        });
    };
    return (
        <>
            {isLoading?(
                <DataLoading small={true} />
            ):(
                <DataTable 
                    columns={columns} 
                    fetcher={InvoicesService.list}
                    searchPlaceholder={t("Search by Account Number or Invoice Number or Customer Name or E-Mail...")}
                    defaultFilterConfig={defaultFilterConfig}
                    actions={(data, context) => {
                        return (
                            <>
                                <TableAction disabled={downloading} onClick={(e) => handleDownloadPdf(data)}>{downloading === data.id?"Downloading...":t("Download")}</TableAction>
                            </>
                        )
                    }}
                />
            )}
            
        </>
    )
}